import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiltersListComponent } from './filters-list.component';

@NgModule({
  declarations: [FiltersListComponent],
  imports: [
    CommonModule,
  ],
  exports: [FiltersListComponent],
})
export class FiltersListModule {
}
